module.exports = __webpack_public_path__ + "img/part2.673e6d5c.png";